import { IFile, IFormField } from "@/interfaces";
import _ from "lodash";

/**
 * TODO: Be be removed during Cosmos DB update
 * User Story 31600: Cosmos Data Conversion for inconsistencies codebase variable names
 * https://dev.azure.com/MilwaukeeToolAppDev/Moon%20Men/_workitems/edit/31600
 * See for changes:
 * https://dev.azure.com/MilwaukeeToolAppDev/Viper/_git/Met.Viper.Web/pullrequest/20460?path=/src/Web/ClientApp/src/services/adminForms.js&_a=files
 */
export const camelCaseFixIntakeForm = (
  intakeForm: IFormField[]
): IFormField[] => {
  intakeForm.forEach(({ children, property }) => {
    property.productCategoryIds = property.ProductCategoryIds;
    property.property = property.property ?? {
      status: property.Property?.Status,
    };
    property.lockOnSubmission =
      property.lockOnSubmission ?? property.LockOnSubmission;
    property.name = _.camelCase(property.name);

    delete property.ProductCategoryIds;
    delete property.Property;
    delete property.LockOnSubmission;

    if (children?.length) {
      children = camelCaseFixIntakeForm(children);
    }
  });
  return intakeForm;
};

export interface ICamelCaseFixProject {
  multipleFileAttachmentsRequired?: ICamelCaseFixFile[];
  multipleFileAttachmentsNotRequired?: ICamelCaseFixFile[];
  projectFocus: string[];
  /** @deprecated */
  project_Focus?: string;
}

interface ICamelCaseFixFile extends IFile {
  Url?: string;
  Name?: string;
  ContentType?: string;
  BlobListIds?: string[];
}

export const camelCaseFixProject = (
  project: ICamelCaseFixProject
): ICamelCaseFixProject => {
  const requiredFileList: ICamelCaseFixFile[] = [];
  const optionalFileList: ICamelCaseFixFile[] = [];
  project.multipleFileAttachmentsRequired?.forEach((uploadFile) => {
    uploadFile.url = uploadFile.Url || uploadFile.url;
    uploadFile.name = uploadFile.Name || uploadFile.name;
    uploadFile.contentType = uploadFile.ContentType || uploadFile.contentType;
    uploadFile.blobListIds = uploadFile.BlobListIds || uploadFile.blobListIds;

    delete uploadFile.Url;
    delete uploadFile.Name;
    delete uploadFile.ContentType;
    delete uploadFile.BlobListIds;
    requiredFileList.push(uploadFile);
  });

  project.multipleFileAttachmentsRequired = requiredFileList;

  project.multipleFileAttachmentsNotRequired?.forEach((uploadFile) => {
    uploadFile.url = uploadFile.Url || uploadFile.url;
    uploadFile.name = uploadFile.Name || uploadFile.name;
    uploadFile.contentType = uploadFile.ContentType || uploadFile.contentType;
    uploadFile.blobListIds = uploadFile.BlobListIds || uploadFile.blobListIds;

    delete uploadFile.Url;
    delete uploadFile.Name;
    delete uploadFile.ContentType;
    delete uploadFile.BlobListIds;
    optionalFileList.push(uploadFile);
  });

  project.multipleFileAttachmentsNotRequired = optionalFileList;

  return project;
};

interface ICamelCaseFixTag {
  /** @deprecated */
  PartitionKey?: string;
  partitionKey?: string;
  /** @deprecated */
  Label?: string;
  label?: string;
  /** @deprecated */
  Color?: string;
  color?: string;
  /** @deprecated */
  Targets?: string[];
  targets?: string[];
}

export const camelCaseFixTag = (tag: ICamelCaseFixTag): ICamelCaseFixTag => {
  tag.partitionKey = tag.partitionKey || tag.PartitionKey;
  tag.label = tag.label || tag.Label;
  tag.color = tag.color || tag.Color;
  tag.targets = tag.targets || tag.Targets;
  return tag;
};
